// src/ui/Turnstile.tsx (T1): the Turnstile widget for public forms (sign-in). Renders nothing without a site key
// (site.turnstileSiteKey is empty in test). `onToken` gets each fresh token, and null when it expires; reset it
// after a failed submit through `ref`. Root class: hb-turnstile.
import { useEffect, useRef } from "preact/hooks";
import { renderTurnstile, type TurnstileWidget } from "../lib/turnstile";

export function Turnstile(props: {
  siteKey: string;
  onToken: (token: string | null) => void;
  action?: string;
  /** "interaction-only": the widget shows only when the visitor has something to do. */
  appearance?: "always" | "execute" | "interaction-only";
  widget?: { current: TurnstileWidget | null };
  onError?: () => void;
}) {
  const el = useRef<HTMLDivElement>(null);
  const onToken = useRef(props.onToken);
  onToken.current = props.onToken;
  useEffect(() => {
    if (!props.siteKey || !el.current) return;
    let widget: TurnstileWidget | null = null;
    let live = true;
    renderTurnstile(el.current, props.siteKey, { onToken: (t) => onToken.current(t), action: props.action, appearance: props.appearance }).then(
      (w) => {
        if (!live) {
          w.remove();
          return;
        }
        widget = w;
        if (props.widget) props.widget.current = w;
      },
      () => props.onError?.(),
    );
    return () => {
      live = false;
      widget?.remove();
      if (props.widget) props.widget.current = null;
    };
  }, [props.siteKey, props.action, props.appearance]);
  if (!props.siteKey) return null;
  return <div class="hb-turnstile" ref={el} />;
}
